<script setup lang="ts">
defineProps({
    as: { type: String, default: 'div' },
});
</script>

<template>
    <UContainer :as="as" class="px-6 xl:px-14">
        <slot />
    </UContainer>
</template>
